import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './AppNotification.scss';

const AppNotification = ({ badgeType, square, reversed, children, info }) => {
  const wrapperClass = classnames('app-notification-badge', {
    [`app-notification-badge-${badgeType}`]: badgeType,
    'app-notification-badge-square': square,
    'app-notification-badge-reversed': reversed,
    'app-notification-badge-info': info,
    'app-notification-badge-filter-panel' : badgeType,
  });

  return (
    <span
      className={wrapperClass}
    >
      {children}
    </span>
  );
};

AppNotification.propTypes = {
  badgeType: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  square: PropTypes.bool,
  reversed: PropTypes.bool,
  info: PropTypes.bool,
};

AppNotification.defaultProps = {
  square: false,
  reversed: false,
  info: false,
};

export default AppNotification;
